import {
  LoadCurrentEvaluation,
  LoadCurrentEvaluationCompleted,
  LoadCurrentEvaluationFailed,
  LoadEvaluations,
  LoadEvaluationsCompleted,
  LoadEvaluationsFailed,
} from './evaluation-load.action';
import { SelectEvaluation, SelectEvaluationCompleted, SelectEvaluationFailed } from './evaluation-select.action';
import {
  AddEvaluationRecommendations,
  AddEvaluationRecommendationsCompleted,
  AddEvaluationRecommendationsFailed,
  AddNewReviewComment,
  AddNewReviewCommentCompleted,
  AddNewReviewCommentFailed,
  DeleteReviewComment,
  DeleteReviewCommentCompleted,
  DeleteReviewCommentFailed,
  RemoveEvaluationRecommendations,
  RemoveEvaluationRecommendationsCompleted,
  RemoveRecommendationsFailed,
  UpdateCurrentEvaluation,
  UpdateCurrentEvaluationCompleted,
  UpdateCurrentEvaluationFailed,
  UpdateCurrentEvaluationRelatedTaskCompleted,
  UpdateEquipmentRecommendationsFailed,
  UpdateEvaluation,
  UpdateEvaluationCompleted,
  UpdateEvaluationFailed,
  UpdateEvaluationRecommendations,
  UpdateEvaluationRecommendationsAll,
  UpdateEvaluationRecommendationsCompleted,
  UpdateEvaluationRecommendationsFailed,
  UpdateReviewComment,
  UpdateReviewCommentCompleted,
  UpdateReviewCommentFailed,
} from './evaluation-update.action';

export { EvaluationActionType } from './evaluation-action-type.enum';

export {
  LoadEvaluations,
  LoadEvaluationsCompleted,
  LoadEvaluationsFailed,
  LoadCurrentEvaluation,
  LoadCurrentEvaluationCompleted,
  LoadCurrentEvaluationFailed,
} from './evaluation-load.action';
export {
  AddNewReviewComment,
  AddNewReviewCommentCompleted,
  AddNewReviewCommentFailed,
  AddEvaluationRecommendations,
  AddEvaluationRecommendationsCompleted,
  AddEvaluationRecommendationsFailed,
  DeleteReviewComment,
  DeleteReviewCommentCompleted,
  DeleteReviewCommentFailed,
  RemoveEvaluationRecommendations,
  RemoveEvaluationRecommendationsCompleted,
  RemoveRecommendationsFailed,
  UpdateEvaluation,
  UpdateEvaluationCompleted,
  UpdateEvaluationFailed,
  UpdateCurrentEvaluationRelatedTaskCompleted,
  UpdateCurrentEvaluation,
  UpdateCurrentEvaluationCompleted,
  UpdateCurrentEvaluationFailed,
  UpdateReviewComment,
  UpdateReviewCommentCompleted,
  UpdateReviewCommentFailed,
  UpdateEquipmentRecommendationsFailed,
  UpdateEvaluationRecommendations,
  UpdateEvaluationRecommendationsAll,
  UpdateEvaluationRecommendationsCompleted,
  UpdateEvaluationRecommendationsFailed,
} from './evaluation-update.action';
export { SelectEvaluation, SelectEvaluationCompleted, SelectEvaluationFailed } from './evaluation-select.action';

export type EvaluationActions =

  LoadEvaluations |
  LoadEvaluationsCompleted |
  LoadEvaluationsFailed |
  LoadCurrentEvaluation |
  LoadCurrentEvaluationCompleted |
  LoadCurrentEvaluationFailed |

  AddNewReviewComment |
  AddNewReviewCommentCompleted |
  AddNewReviewCommentFailed |
  DeleteReviewComment |
  DeleteReviewCommentCompleted |
  DeleteReviewCommentFailed |
  RemoveEvaluationRecommendations |
  RemoveEvaluationRecommendationsCompleted |
  RemoveRecommendationsFailed |
  UpdateEquipmentRecommendationsFailed |
  UpdateEvaluation |
  UpdateEvaluationCompleted |
  UpdateEvaluationFailed |
  UpdateCurrentEvaluation |
  UpdateCurrentEvaluationCompleted |
  UpdateCurrentEvaluationFailed |
  UpdateCurrentEvaluationRelatedTaskCompleted |
  UpdateReviewComment |
  UpdateReviewCommentCompleted |
  UpdateReviewCommentFailed |
  AddEvaluationRecommendations |
  AddEvaluationRecommendationsCompleted |
  AddEvaluationRecommendationsFailed |
  UpdateEvaluationRecommendations |
  UpdateEvaluationRecommendationsAll |
  UpdateEvaluationRecommendationsCompleted |
  UpdateEvaluationRecommendationsFailed |

  SelectEvaluation |
  SelectEvaluationCompleted |
  SelectEvaluationFailed;
